function merge(t, u) {
    for (var _i = 0, _a = Object.keys(u); _i < _a.length; _i++) {
        var k = _a[_i];
        var v = u[k];
        if (t[k]) {
            if (typeof v === 'string') {
                t[k] = v;
            }
            else if (typeof t[k] === 'string') {
                t[k] = v;
            }
            else {
                t[k] = merge(t[k], v);
            }
        }
        else {
            t[k] = v;
        }
    }
    return t;
}
var langs = {};
var language = localStorage.getItem('lang') || 'ru';
function get_translation(root, path) {
    if (!root) {
        throw 'WRONG_OBJECT';
    }
    var i = path.indexOf('.');
    if (i >= 0) {
        var v = root[path.substring(0, i)];
        if (typeof v === 'undefined' || typeof v === 'string') {
            throw 'LONG_PATH';
        }
        return get_translation(v, path.substring(i + 1));
    }
    else {
        var v = root[path];
        if (typeof v === 'string') {
            return v;
        }
        throw 'SHORT_PATH';
    }
}
function add(lang, obj) {
    langs[lang] = langs[lang] || {};
    langs[lang] = merge(langs[lang], obj);
}
function translate(path) {
    return get_translation(langs[language], path);
}
function setLanguage(lang) {
    language = lang;
}

export { add, language, setLanguage, translate };
//# sourceMappingURL=index.mjs.map
